import React from 'react'

import backButtonIcon from '../../assets/unlockPinIcons/back_button.png'

import ErrorBox, { ErrorMessage } from './ErrorBox'

import '../../css/common/SlideInPage.css'

type SlideInPageProps = {
  title: string
  isOpen: boolean
  onClose: () => void
  isError: boolean
  errorMessage: ErrorMessage
  children?: React.ReactNode
}

/**
 * SlideInPage component.
 *
 *
 * This component renders a slide-in page with a header, content area, and an error box.
 * The page slides in from right to left when opened and slides out when closed.
 * It renders the child components passed to it, and if an error occurs, it also renders the error message.
 *
 * @param {SlideInPageProps} props - The props for the component.
 * @returns {JSX.Element} The rendered slide-in page component.
 */
const SlideInPage: React.FC<SlideInPageProps> = ({
  title,
  isOpen,
  onClose,
  isError,
  errorMessage,
  children,
}: SlideInPageProps): JSX.Element => {
  return (
    <div className={`slide-in-page ${isOpen ? 'open' : ''}`}>
      <div className="slide-in-page-header">
        <button
          onClick={onClose}
          style={{ border: 'none', background: 'none' }}
        >
          <img
            alt="Back Button"
            className="back-button-icon"
            src={backButtonIcon}
          />
        </button>
        <h2 className="slide-in-page-title">{title}</h2>
      </div>
      <div>{children}</div>
      <ErrorBox
        isOpen={isError && isOpen}
        onClose={onClose}
        errorMessage={errorMessage}
      />
    </div>
  )
}

export default SlideInPage
